import { render } from "./ClientCreatePassport.vue?vue&type=template&id=8d0b46ba"
import script from "./ClientCreatePassport.vue?vue&type=script&lang=js"
export * from "./ClientCreatePassport.vue?vue&type=script&lang=js"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__